module.exports = __webpack_public_path__ + "static/hologram-f9023cdfe938d18286fe42231ac7398c.jpg";